import { StrategicTheme, CloudProvider } from "../types";
import { GetApp as DriveIcon, Microsoft as OneDriveIcon, GitHub as GitHubIcon, Storage as AwsIcon, Cloud } from "@mui/icons-material";

// Strategic themes for initiative creation
export const STRATEGIC_THEMES: StrategicTheme[] = [
    {
        id: "growth",
        name: "Growth",
        description: "New markets/revenue streams, customer acquisition, business expansion",
        examples: ["Market expansion", "New product launch", "Customer acquisition"]
    },
    {
        id: "efficiency",
        name: "Efficiency",
        description: "Process automation, cost reduction, operational improvements",
        examples: ["Process automation", "Workflow optimization", "Cost reduction"]
    },
    {
        id: "compliance",
        name: "Compliance",
        description: "Legal/security requirements, regulatory adherence, risk mitigation",
        examples: ["Security compliance", "Regulatory requirements", "Risk mitigation"]
    },
    {
        id: "innovation",
        name: "Innovation",
        description: "Technology adoption, R&D initiatives, competitive differentiation",
        examples: ["Technology adoption", "R&D projects", "Product innovation"]
    },
    {
        id: "customer",
        name: "Customer Experience",
        description: "User satisfaction, service improvements, customer retention",
        examples: ["User experience", "Customer service", "Retention programs"]
    }
];

// Available team roles
export const TEAM_ROLES = [
    "Product Managers",
    "Developers",
    "Designers",
    "QA Engineers",
    "DevOps",
    "Data Analysts",
    "Legal",
    "IT",
    "Compliance",
    "Marketing",
    "Sales",
    "Customer Support",
    "Finance",
    "HR",
    "Operations"
];

// Cloud providers for file upload
export const CLOUD_PROVIDERS: CloudProvider[] = [
    { id: "drive", name: "Google Drive", icon: DriveIcon, color: "#4285F4" },
    { id: "dropbox", name: "Dropbox", icon: Cloud, color: "#0061FF" },
    { id: "onedrive", name: "OneDrive", icon: OneDriveIcon, color: "#0078D4" },
    { id: "github", name: "GitHub", icon: GitHubIcon, color: "#24292E" },
    { id: "aws", name: "AWS S3", icon: AwsIcon, color: "#FF9900" }
];

// Enhanced Work Product Library Data with comprehensive work products
// @deprecated - This data is now loaded from the API via /api/workproducts/activeworkproductlistings
// Kept for backward compatibility only. Will be removed in future versions.
export const WORK_PRODUCT_LIBRARY = {
    discovery: [],
    design: [],
    code: [],
    qa: [],
    deploy: []
};

export const CHAT_SUGGESTIONS = [
    "Help me create a Product Requirements Document",
    "What's the best practice for competitive analysis?",
    "Review my current work products",
    "Suggest improvements for my SDLC process"
];

// REMOVED: Work products child generation - Reset to single level structure
// Work products now only create the single work product when moved to Active area
export const WORK_PRODUCTS_WITH_CHILDREN = {};
